import { render, staticRenderFns } from "./listpage.vue?vue&type=template&id=38cbc5a5&"
import script from "./listpage.vue?vue&type=script&lang=js&"
export * from "./listpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports